import React from 'react';
import OAuthGrantTypeField from './OAuthGrantTypeField';
import OAuthRedirectUriField from './OAuthRedirectUriField';
import DownloadUrlField from './DownloadUrlField';
import OriginalUrlsWhitelist from './OriginalUrlsWhitelistField';

const ApplicationFieldsGroup: React.FC<{}> = () => {
  return (
    <>
      <OAuthGrantTypeField />
      <OAuthRedirectUriField />
      <DownloadUrlField />
      <OriginalUrlsWhitelist />
    </>
  );
};
ApplicationFieldsGroup.displayName = 'ApplicationFieldsGroup';

export default ApplicationFieldsGroup;
